import merge from 'lodash/merge';
import BackboneElement from './BackboneElement';

export default class BN_Asam4AssessmentSubdimensionCheckboxAddOn extends BackboneElement {
    static __className = 'BN_Asam4AssessmentSubdimensionCheckboxAddOn';

    __objectStructure = {
        id: String,
        text: String,
        riskRating: String,
        label: String,
    };

    constructor(constructJson, className = 'BN_Asam4AssessmentSubdimensionCheckboxAddOn') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
